import { makeVar } from '@apollo/client';
import { MessageTemplateType } from '../../types/MessageTemplate';

const vMessageTemplateVar = makeVar<MessageTemplateType | undefined>(undefined);

export default vMessageTemplateVar;
